import { createElement } from '@wordpress/element';
import { TextInput, Toggle, RadioGroup } from '../admin/components/ui';

export const renderInputRow = (
    label,
    key,
    type = 'text',
    options = [],
    _checkboxLabel = '',
    Settings = {},
    updateSetting = () => {},
    disabled = false,
) => {
    const isToggle = type === 'checkBox';
    const isRadio  = type === 'radio';

    return (
        <div key={key} className={`pqd-field-row${isToggle ? ' pqd-field-row--toggle' : ''}${isRadio ? ' pqd-field-row--radio' : ''}`}>
            <div className="pqd-field-label">{label} {disabled && <span className="pqd-pro-badge"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M3 7l4 4 5-7 5 7 4-4-2 13H5L3 7z"/></svg>PRO</span>}
            </div>
            <div className="pqd-field-control">
                <div style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
                    {isToggle ? (
                        <Toggle
                            checked={Settings[key] === 'yes'}
                            onChange={val => updateSetting(key, val ? 'yes' : 'no')}
                            label
                        />
                    ) : isRadio ? (
                        <RadioGroup
                            selected={Settings[key]}
                            options={options}
                            onChange={val => updateSetting(key, val)}
                        />
                    ) : (
                        <TextInput
                            type={type === 'number' ? 'number' : 'text'}
                            value={Settings[key] || ''}
                            onChange={val => updateSetting(key, val)}
                        />
                    )}
                </div>
                {disabled && (
                    <span style={{ fontSize: 12, color: '#64748b', marginTop: 4, display: 'block' }}>
                        This Option Available in{' '}
                        <a
                            href="https://www.plugin999.com/plugin/product-quantity-dropdown-for-woocommerce/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#6366f1', fontWeight: 600, textDecoration: 'underline' }}
                            onClick={e => e.stopPropagation()}
                        >
                            Pro Version
                        </a>
                    </span>
                )}
            </div>
        </div>
    );
};